import { PersonModel, ScheduleModalPeople } from '@/types';

export const person: PersonModel = {
  name: 'Jan',
  surname: 'Ellwitz',
  position: 'Business Manager',
  linkedinLink: 'https://www.linkedin.com/in/j-ellwitz/',
  modal: ScheduleModalPeople.janE
};
